import axios from "axios";
import queryString from "query-string";

const SubscriptionServices = {
  addExternalLink: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/external-link`,
      {
        label: data.label, // string,
        description: data.description, // string,
        url: data.url, // string,
        subscriptions: data.subscriptions, // [integer],
        enterprise: data.enterprise, // integer,
      }
    );
    return response;
  },
  updateExternalLink: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/external-link`,
      {
        external_link_id: data.external_link_id, // integer,
        label: data.label, // string,
        description: data.description, // string,
        url: data.url, // string,
        subscriptions: data.subscriptions, // [integer],
        enterprise: data.enterprise, // integer,
      }
    );
    return response;
  },
  deleteExternalLink: async (external_link_id, subscriptions = "[]") => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL +
        `/eira/external-link?external_link_id=${external_link_id}&subscriptions=${subscriptions}`
    );
    return response;
  },
  /*   
  getExternalLink: Ningún parámetro es obligatorio, si el superadmin no envía entrerprise ni subscription entonces 
  lista todos los links de todas las empresas. Para los demas roles enterprise no es necesario, 
  porque calcula la empresa que administra. */
  getExternalLink: async (enterprise, subscription) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/external-link?enterprise=${enterprise}&subscription=${subscription}`
    );
    return response;
  },
  getSubscriptionGroups: async (data) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/subscription-group?${queryString.stringify(data)}`
    );
    return response;
  },
  postSubscriptionGroup: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/subscription-group`,
      {
        subscription_id: data.subscription_id, // integer,
        name: data.name, // string,
        start_date: data.start_date, // string,
        registration_end_date: data.registration_end_date, // string,
        users_limit: data.users_limit, // integer,
        protocol_jump: data.protocol_jump, // integer,
      }
    );
    return response;
  },
  putSubscriptionGroup: async (data) => {
    const response = await axios.put(
      process.env.REACT_APP_API_URL + `/eira/subscription-group`,
      {
        group_id: data.group_id, // integer,
        name: data.name, // string,
        start_date: data.start_date, // string,
        registration_end_date: data.registration_end_date, // string,
        users_limit: data.users_limit, // integer,
        protocol_jump: data.protocol_id, // integer,
      }
    );
    return response;
  },
  deleteSubscriptionGroup: async (group_id) => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL +
        `/eira/subscription-group?group_id=${group_id}`
    );
    return response;
  },
  getSubscriptionTemplates: async (subscription_id) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/ses-template?subscription_id=${subscription_id}`
    );
    return response;
  },
  getTemplateByName: async (subscription_id, template_name) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/ses-template?subscription_id=${subscription_id}&template_name=${template_name}`
    );
    return response;
  },
  updateSubscriptionInviteTemplate: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/ses-template`,
      data
    );
    return response;
  },
  unsubscribe: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/service/unsubscribe`,
      data
    );
    return response;
  },
};

export default SubscriptionServices;
